<template>
  <v-container :class="isSPSize ? 'sp' : ''">
    <v-row>
      <v-col col="12">
        <h1 :class="h1Style" class="title-border">
          利用規約
        </h1>
        <p>
           この利用規約（以下「本件規約」といいます。）は、株式会社Attic Start（以下「当社」といいます。）が、当社のウェブサイトで提供するサービス（以下「本件サービス」といいます。）の利用条件・利用ルールを定めるものです。本件サービスをご利用されるユーザーの方々（以下「ユーザー」といいます。）におかれましては、必ず、本件規約を遵守し、本件サービスをご利用ください。本件規約に同意できない場合は、本件サービスの利用はいただけません。
        </p>
        <p>
          第1条　適用
        </p>
        <p>
          本件規約は、本件サービスの利用に関わるユーザーと当社との一切の関係に適用されます。本件規約に加えて、当社が電子メール・ウェブサイト等で発信する個別の利用条件・利用ルールも、本件規約の一部を構成します。
        </p>
        <p>
          第２条　本件サービスの内容
        </p>
        <ol class="mb-3">
          <li>本件サービスは、海外からの旅行者（以下、本件サービスでは「旅行者」といいます。）と、その旅行者の旅先において活動または居住する人々（以下、本件サービスでは「ローカル」といいます。）をマッチングすることを主たる目的とするプラットフォームサービスです。但し、旅行者以外の者が旅行者として、またはローカル以外の者がローカルとして本件サービスを利用する可能性や旅行者同士・ローカル同士のマッチングに利用される可能性が排除されているものではありません。</li>
          <li>本件サービスを、商業目的（物品販売、特定のサービス・店舗等への送客、宣伝などを含む）、宗教・特定の団体の勧誘目的、異性との交流目的等、当社が意図する国際交流以外の目的で使用することはできません。</li>
        </ol>
        <p>
          第３条　利用登録
        </p>
        <ol class="mb-3">
          <li>
            ユーザーが、本件規約に同意の上、本件サービスの利用を申請し、当社がこれを承認することによって、利用登録が完了するものとします。但し、当社が次のいずれかの事由が存在する又は存在するおそれがあると判断した場合、ユーザーの利用登録について、拒否、取消、停止等の措置をとることがあります。当社の措置の理由について、当社は、一切の開示義務を負いません。
            <ol class="mb-3 list_parentheses">
              <li>利用登録の申請に際して、虚偽または不正確な事項を届け出た場合</li>
              <li>過去に利用登録を拒否・取消・停止されたことがある場合</li>
              <li>過去、現在を問わず、本件規約に違反した又は違反した可能性があると当社が判断した場合</li>
              <li>本件サービス利用後に、フィードバックの提供等当社の求めに協力しない場合</li>
              <li>本件サービスの利用にあたって他のユーザー、当社スタッフまたは第三者に不快感を与える言動をしたと当社が判断した場合</li>
              <li>その他、当社が利用登録または利用継続を相当でないと判断した場合</li>
            </ol>
          </li>
          <li>本件サービスを利用できる者は、満１８歳以上の自然人に限ります。また、代理人による登録はできません。</li>
          <li>暴力団等の反社会的勢力に属する者または関係する者は、利用登録することはできません。</li>
          <li>ユーザーは、いかなる場合にも、第１項の利用登録に基づく地位を、第三者に譲渡または貸与することはできません。</li>
          <li>ユーザーは、当社への登録事項に変更が生じた場合は、当社所定の方法により、当社に対し、速やかに変更内容を届け出る必要があります。届出を行わなかったことにより、ユーザーが不利益または損害を被ったとしても、当社はその責任を一切負いません。</li>
          <li>第１項の利用登録の完了は、本件サービスの利用を確約・保証するものではありません。</li>
        </ol>
        <p>
          第４条（利用規約の変更）
        </p>
        <ol class="mb-3">
          <li>
            当社は以下の場合に、当社の裁量により、利用規約を変更することができます。
            <ol class="mb-3 list_parentheses">
              <li>利用規約の変更が、ユーザーの一般の利益に適合するとき</li>
              <li>利用規約の変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らし合理的なものであるとき</li>
            </ol>
          </li>
          <li>当社は前項による利用規約の変更にあたり、変更後の利用規約の効力発生日の１週間前までに、利用規約を変更する旨及び変更後の利用規約の内容とその効力発生日を当社ウェブサイト（<a href="https://paikeout.com" target="_blank">https://paikeout.com</a>）に掲示し通知します。</li>
          <li>本件サービスの利用毎に、本件規約を必ず、ご確認ください。</li>
        </ol>
        <p>
          第５条　本件サービス内容の変更等
        </p>
        <ol class="mb-3">
          <li>当社は、ユーザーに通知することなく、本件サービスの内容の変更または提供の中止をすることができるものとします。</li>
          <li>前項の当社の措置によって、ユーザーまたは第三者に何らかの不利益または損害が生じたとしても、当社は、一切の責任を負いません。</li>
        </ol>
        <p>
          第６条　ユーザーの個人情報等の取り扱い
        </p>
        <p>
          当社は、本件サービスの利用に際してユーザーから取得した氏名、メールアドレス等の個人情報等を、本件利用規約及び当社が別に定めるプライバシーポリシーに基づき、適切に取り扱うものとします。
        </p>
        <p>
          第７条　個人情報等の第三者提供の同意
        </p>
        <p>
          ユーザーは、本件サービスを利用するにあたって、当社が別途定めるプライバシーポリシーに基づきユーザーの個人情報等の情報が第三者に提供されることについて、あらかじめ同意するものとします。
        </p>
        <p>
          第８条　知的財産権等の権利帰属等
        </p>
        <ol class="mb-3">
          <li>本件サービスにかかるすべての写真、データ、イラスト、ソフトウェア、資料、デザイン、図表等に関する所有権及び知的財産権（著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権を意味します。）、その他一切の権利は、当社に帰属します。</li>
          <li>本件規約に定めるユーザー登録に基づく本件サービスの利用許諾は、当社の保有・使用する知的財産権その他一切の権利について、使用または利用を許諾するものではありません。</li>
          <li>ユーザーは、いかなる理由によっても、当社または第三者の保有する知的財産権その他一切の権利を侵害し、または侵害するおそれのある行為をしてはいけません。</li>
          <li>ユーザーは、ユーザーが当社に提供する写真、イラスト、フィードバック（アンケートへの回答を含む）及びレポートその他のデータについて、当社に対し、世界的、非独占的、無償、サブライセンス可能かつ譲渡可能な使用、複製、配布、派生著作物の作成、表示及び実行に関するライセンスを付与します。その提供方法は、Eメールでの送信、当社が運営するウェブサイト及び当社が管理するSNSへのアップロード等、その態様を問わないものとします。</li>
          <li>ユーザーは、当社及び当社から権利を承継または許諾された者に対して著作者人格権を行使しないことに同意するものとします。</li>
        </ol>
        <p>
          第９条　禁止事項
        </p>
        <ol class="mb-3">
          <li>
            本件サービスの利用にあたって、ユーザーが、自己または第三者を利用して、次のいずれかに該当する行為、またはそのおそれのある行為をすることは禁止されています。
            <ol class="mb-3 list_parentheses">
              <li>本件規約、当社が定めたルール、当社からの指示等に違反する行為</li>
              <li>利用登録にあたって、虚偽または不正確な情報を申告・提供する行為</li>
              <li>犯罪行為、公序良俗に反する行為、法令違反行為</li>
              <li>本件サービスを、商業目的（物品販売、特定のサービス・店舗等への送客、店舗からのキックバック、宣伝などを含む）、宗教・特定の団体の勧誘目的、異性との交流目的等、当社が意図する国際交流以外の目的で使用する行為</li>
              <li>営利・非営利を問わず、本件サービスを自己又は第三者の事業・活動に利用する行為</li>
              <li>当社スタッフ、ユーザーまたは第三者に不快感を与える言動</li>
              <li>当社、ユーザー、その他第三者の知的所有権、肖像権、プライバシー権およびその他の権利や利益を侵害する、または侵害するおそれのある行為</li>
              <li>コンピューターウィルス等有害なコンピュータープログラムを含むデータ・情報を伝達、拡散、組み込む等の行為</li>
              <li>本件サービスの利用にあたって、当社、ユーザーまたは第三者に虚偽または不正確な情報を申告・提供等する行為</li>
              <li>通常の範囲を超えて本件サービスのサーバーに負担を及ぼす等、本件サービスの運営に支障をきたす行為</li>
              <li>当社の業務または本件サービスの運営を妨げるまたは妨げるおそれのある行為</li>
              <li>本件サービスまたは本サービスを利用する過程で入手した情報もしくは資料を、本サービスと無関係な目的で利用する行為</li>
              <li>当社が許容する以外の方法で本件サービスを利用する行為</li>
              <li>ユーザーまたは第三者に本条に定める禁止行為を勧誘または助長する行為</li>
              <li>当社、当社スタッフ、ユーザーまたは本件サービスの信用・信頼を失墜・毀損させる行為またはそのおそれのある行為</li>
              <li>その他、当社が不適切と判断する行為</li>
            </ol>
          </li>
          <li>
            当社は、ユーザーの行為が前項のいずれかに該当するまたは該当するおそれがあると判断した場合、ユーザーへの事前の通知なく、利用登録の抹消、本件サービスの利用停止等の措置を講じることができるものとします。
          </li>
          <li>
            当社は、当社の前項の措置に基づいてユーザーまたは第三者に何らかの不利益または損害が生じたとしても、一切の責任を負いません。
          </li>
        </ol>
        <p>
          第１０条　免責等
        </p>
        <ol class="mb-3">
          <li>当社は、本件サービスがユーザーの特定の目的に適合すること、及び期待する機能、価値、正確性、有用性を有すること、ユーザーによる本件サービスの利用がユーザーに適用のある法令又は規則等に適合すること、本件サービスが継続的に利用できること、及び不具合が生じないこと、並びに本件サービスにより提供される情報及びユーザーに関する情報の完全性、正確性、真実性等については、明示又は黙示を問わず、何ら確約・保証するものではありません。</li>
          <li>ユーザーは自らの責任に基づいて本件サービスを利用するものとし、当社は本件サービスにおけるユーザーに関する一切の事項について、何らの責任を負いません。</li>
          <li>当社が何らかの事由によって責任を負う場合であっても、関連するコンテンツの対価の相当額を超えて損害を賠償する責任を負いません。また、当社は、付随的損害、間接損害、特別損害、将来の損害及び逸失利益にかかる損害については、賠償する責任を負わないこととします。</li>
          <li>ユーザーは、当社及び本件サービスが、ユーザー同士のマッチングの場を提供するのみに留まることを確認し、マッチングそれ自体及びマッチング以降にユーザー間またはユーザーと第三者間に生じるいかなる取引、紛争等について、当事者間で各自の負担をもって解決するものとし、当社は一切の責任を負わないものとします。</li>
          <li>ユーザーによる本件サービスの利用等に関して、当該ユーザーの故意・過失（軽過失を含みます。）に基づき、他のユーザーその他の第三者から、当社に対して損害の賠償請求があった場合、当該ユーザーは当社に対して事案解決のために協力する義務を負うとともに、当該請求にかかる一切の損害及び費用につき、補償する義務があります。</li>
        </ol>
        <p>
          第１１条　本件サービスの一時的な中断
        </p>
        <ol class="mb-3">
          <li>
            当社は、次のいずれかの事由に該当する場合、ユーザーに事前に通知することなく、本件サービスの提供を中断することがあります。
            <ol class="mb-3 list_parentheses">
              <li>本件サービス及びそれに付随するシステム・関連設備等の保守メンテナンスを実施する場合</li>
              <li>当社が利用する通信回線、ソフトウェアサービス、電力等の利用・供給ができなくなった場合</li>
              <li>火災、停電、地震、台風、洪水、津波等の天災その他の非常事態が発生した場合、またはそのおそれが生じた場合</li>
              <li>法令上の対応、行政官庁等の指導・要請に基づく対応を行う場合</li>
              <li>本件サービスの利用登録数が当社の本件サービスの対応能力を超える場合</li>
              <li>その他、物理的・技術的な事由により本サービスの提供ができなくなったとき</li>
            </ol>
          </li>
          <li>当社は、本件サービスの提供が遅滞、中断した場合、その提供が不完全な場合でも、これらに起因してユーザーまたは第三者が被った一切の不利益または損害について、一切責任を負わないものとします。</li>
        </ol>
        <p>
          第１２条　退会
        </p>
        <p>
          ユーザーは、本件サービスの利用を終了、または登録を抹消したい場合（以下「退会」といいます。）は、当社所定の方法に従って、当社に対し申告するものとします。
        </p>
        <p>
          第１３条　譲渡
        </p>
        <p>
          ユーザーは、当社の書面による事前の承諾なく、本件規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。
        </p>
        <p>
          第１４条 準拠法と裁判管轄
        </p>
        <ol class="mb-3">
          <li>本件規約の準拠法は日本法とします。</li>
          <li>本件サービスに関連して紛争が生じた場合には、紛争の如何に拘わらず、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
        </ol>
        <p class="text-right">以上</p>
        <p>
          作成日 2020年3月27日
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn
          rounded
          large
          dark
          align-items="center"
          color="gray"
          width="250"
          class="font-weight-bold text-capitalize"
          @click="$router.go(-1)"
        >
          Back
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    h1Style() {
      return this.isSPSize
        ? 'font-h1-sp font-weight-bold mb-3'
        : 'font-h1-pc font-weight-bold mb-5'
    },
    isSPSize() {
      return this.$vuetify.breakpoint.name === 'xs'
    },
  },
};
</script>

<style lang="stylus" scoped>
p
  line-height 1.5
  font-size 15px

.sp
  p, ul, ol
    font-size 12px

ol.list_parentheses
  padding 0 0 0 2em
  margin 0
  li
    list-style-type none
    list-style-position inside
    counter-increment cnt
    padding-left 1.5em
    text-indent -1.5em
    &:before
      display marker
      content "(" counter(cnt) ") "

</style>